import React, {Fragment} from "react";
import Button from "@mui/material/Button";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {useTheme} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery/useMediaQuery";
import CircularProgress from '@mui/material/CircularProgress';

function OutlineButton({ label, action, disabled }) {
  return(
      <Button
          sx={styles.buttonBordered}
          type="submit"
          onClick={action}
          variant="contained"
          disableElevation
          disabled={disabled}
      >
        {label}
      </Button>
  )
}

function SolidButton({label, action, disabled, isLoading}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return(
      <Button
          sx={styles.solidButton}
          type="submit"
          onClick={action}
          disabled={disabled}
          variant="contained"
          disableElevation
          endIcon={ isLoading ?
            <CircularProgress size={25} sx={styles.progress}/> :
            ( isMobile ? <ArrowForwardIcon/> : <Fragment/>) }
      >
        {label}
      </Button>
  )
}

export const buttonContained = {
  OutlineButton,
  SolidButton,
};

const styles = {
  buttonBordered: {
    width: '100%',
    fontSize: '16px',
    padding: '10px 30px',
    color: '#0f0a06',
    fontFamily: 'FustatSemiBold',
    textTransform: 'none',
    borderRadius: '50px',
    backgroundColor: '#ffffff',
    border: '1px solid #003300',
    lineHeight: 1,
    ':hover': {
      backgroundColor: '#ffffff',
      color: '#002900',
    },
    ':disabled': {
      color: '#94a694',
      backgroundColor: '#ffffff',
      border: '1px solid #94a694'
    },
    ':focus': {
      outline: '0'
    }
  },
  progress: {
    color: '#ffffff',
    marginLeft: '10px'
  },
  solidButton: {
    width: 'fit-content',
    fontSize: '16px',
    padding: '11px 24px',
    color: '#0f0a06',
    fontFamily: 'FustatSemiBold',
    lineHeight: 1,
    textTransform: 'none',
    borderRadius: '50px',
    backgroundColor: '#74c4ec',
    ':hover': {
      backgroundColor: '#54b0e6',
      color: '#0f0a06',
    },
    ':disabled': {
      color: '#211e1c',
      backgroundColor: '#89cdef'
    },
    ':focus': {
      outline: '0'
    }
  }
};